import coreRouteMap from './store/Routes/routesMap';
import userReducer from './store/User/reducer';
import companyReducer from './store/Company/reducer';
import appReducer from './store/App/reducer';
import notificartionsReducer from './store/Notifications/reducer';
import snackReducer from './store/Snack/reducer';

export const APP_NAME = 'core';

export const reducersMap = {
  user: userReducer,
  company: companyReducer,
  notifications: notificartionsReducer,
  snack: snackReducer,
  app: appReducer,
};

export default {
  name: APP_NAME,
  reducers: () => reducersMap,
  routesMap: async () => coreRouteMap,
};
